import React from "react";
import PropTypes from "prop-types";
import { getDecodedHtml } from "utils/getDecodedHtml";

const DocumentLink = (props) => {
	const { item, icon } = props;
	return (
		<li className="document-link-item">
			<a
				aria-label={item.type === "download" ? "document download" : "document link"}
				tabIndex="0"
				className="document-link-item-action"
				href={item.url}
				rel={item.type === "download" ? "" : "noreferrer"}
				target={item.type === "download" ? "_self" : "_blank"}
			>
				<div
					className="item-title"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.name) }}
				></div>
				{icon ? <div className="item-icon">{icon}</div> : null}
			</a>
		</li>
	);
};

DocumentLink.propTypes = {
	icon: PropTypes.shape({}),
	item: PropTypes.shape({
		name: PropTypes.string,
		url: PropTypes.string,
		type: PropTypes.string
	})
};
export default DocumentLink;
